<script setup lang="ts">
import ElementalPage from '../../@components/ElementalPage.vue'
import { ElementalTypeEnum } from '~~/src/types/elemental'

const url = getElementalTypeRoute(ElementalTypeEnum.Automation)
</script>

<template>
  <ElementalPage :type="ElementalTypeEnum.Automation" :elemental-page-url="url" />
</template>
